// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/shared/Gallery/gallery.scss
// module id = 1438
// module chunks = 10